"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Text_1 = __importDefault(require("../../Text"));
var Avatar_1 = __importDefault(require("../Avatar"));
var Dot_1 = __importDefault(require("../Dot"));
var BadgeIcon_1 = __importDefault(require("./BadgeIcon"));
var constants_1 = require("./constants");
var styles_1 = require("./styles");
var Badge = function (props) {
    var children = props.children, _a = props.color, color = _a === void 0 ? 'primary' : _a, _b = props.mode, mode = _b === void 0 ? 'dark' : _b, disabled = props.disabled;
    var colors = react_2.useMemo(function () { return constants_1.getBadgeColors(mode, color, disabled); }, [mode, color, disabled]);
    var badgeStyle = react_2.useMemo(function () { return styles_1.createBadgeStyle(colors.backgroundColor, colors.color); }, [colors]);
    var spacingStyle = react_2.useMemo(function () { return styles_1.createBadgeSpacingStyle(props); }, [props]);
    return (react_1.jsx(Text_1.default, { color: "inherit", size: 12, weight: 500, css: [badgeStyle, spacingStyle] },
        'icon' in props && props.icon ? (react_1.jsx(BadgeIcon_1.default, { icon: props.icon, css: { color: colors.iconColor } })) : null,
        'dot' in props && props.dot ? (react_1.jsx(Dot_1.default, { size: "sm", css: { backgroundColor: colors.dotColor } })) : null,
        'avatarUrl' in props && props.avatarUrl ? (react_1.jsx(Avatar_1.default, { name: "", src: props.avatarUrl, placeholderType: "icon", size: "2xs" }))
            : null,
        children ? react_1.jsx("span", null, children) : null));
};
exports.default = Badge;
